




























import { defineComponent, ref } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "SensitiveContentConfirm",
  components: { BaseConfirm, BaseButton },
  setup(_, { emit }) {
    const loadingConfirm = ref(false);
    const loadingDecline = ref(false);

    const confirm = (value: boolean) => {
      value ? (loadingConfirm.value = true) : (loadingDecline.value = true);
      emit("confirm", value, () => (loadingConfirm.value = loadingDecline.value = false));
    };
    return { loadingConfirm, loadingDecline, confirm };
  },
});
